import {brand, Branded, TypeOf} from 'io-ts';
import {PositiveInt} from './PositiveInt';

interface OperationIdBrand {
    readonly OperationId: unique symbol;
}

export const OperationId = brand(PositiveInt, (n): n is Branded<PositiveInt, OperationIdBrand> => true, 'OperationId');

export type OperationId = TypeOf<typeof OperationId>;
